<div class="flex flex-col space-y-2 md:p-4">

  <div class="grid grid-cols-3 grid-cols-[10%_30%_60%] md:grid-cols-[10%_50%_40%]
  mr-0.5 md:mr-0 overflow-hidden">
    <a routerLink="/dashboard">
      <div class="pt-4.0 h-8 w-8" id="performance-back-arrow">
      </div>
    </a>
    <div><h1 class="pt-2.5">Performance</h1></div>

    <div class="flex justify-center items-center space-x-2 bg-gray-100 rounded-md mr-2 md:mr-0 w-auto overflow-hidden">

      @if (this.selectedInterval() === 'day') {
        <app-day-datepicker [date]="selectedDate()" (dateChange)="updateDate($event)"></app-day-datepicker>
      }

      @if (this.selectedInterval() === 'month') {
        <app-month-datepicker [date]="selectedDate()" (dateChange)="updateDate($event)"></app-month-datepicker>
      }

      @if (this.selectedInterval() === 'year') {
        <app-year-datepicker [date]="selectedDate()" (dateChange)="updateDate($event)"></app-year-datepicker>
      }

    </div>
  </div>
  <mat-button-toggle-group [value]="selectedInterval()" (change)="onIntervalSelectionChange($event)"
                           class="flex justify-center md:border-1 border-0 border-t border-b border-l-0 border-r-0
                           rounded-none md:rounded-lg border-gray-200">
    <mat-button-toggle value="day" class="flex-1 border-gray-200">
      Tag
    </mat-button-toggle>
    <mat-button-toggle value="month" class="flex-1 border-gray-200"
                       disabled="{{this.selectedChartOption() === 'origin'}}">
      Monat
    </mat-button-toggle>
    <mat-button-toggle value="year" class="flex-1 border-gray-200"
                       disabled="{{this.selectedChartOption() === 'origin' || (this.selectedChartOption() === 'performance' &&  this.selectedEnergyOption() === 'battery' && this.selectedBatteryOption() === 'charge')}}">
      Jahr
    </mat-button-toggle>
    <mat-button-toggle value="all" class="flex-1 border-gray-200" disabled="true">
      Gesamt
    </mat-button-toggle>
  </mat-button-toggle-group>

  <mat-button-toggle-group id="performance-mode" [value]="selectedEnergyOption()"
                           (change)="onEnergySelectionChange($event)"
                           class="flex justify-center
                           md:border-1 border-0 border-t border-b border-l-0 border-r-0
                           rounded-none md:rounded-lg border-gray-200">
    <mat-button-toggle value="production" class="flex-1 border-gray-200 bg-production-yellow">
      Produktion
    </mat-button-toggle>
    <mat-button-toggle value="consumption" class="flex-1 border-gray-200 bg-consumption-blue">
      Verbrauch
    </mat-button-toggle>
    <mat-button-toggle value="battery" class="flex-1 border-gray-200 bg-battery-green">
      Speicher
    </mat-button-toggle>
    <mat-button-toggle value="grid" class="flex-1 border-gray-200 bg-net-black">
      Netz
    </mat-button-toggle>
  </mat-button-toggle-group>

  @if (this.selectedEnergyOption() === 'production' && this.selectedInterval() === 'day') {
    <mat-button-toggle-group [value]="selectedChartOption()" (change)="onChartSelectionChange($event)"
                             class="custom-switch flex justify-center border-gray-200
                             mr-2 ml-2  md:mr-36 md:ml-36 mb-3.5 rounded-lg">
      <mat-button-toggle value="performance" class="flex-1 border-gray-200 ">
        Leistung
      </mat-button-toggle>
      <mat-button-toggle value="origin" class="flex-1 border-gray-200">
        Verwendung
      </mat-button-toggle>
    </mat-button-toggle-group>

  }

  @if (this.selectedEnergyOption() === 'consumption' && this.selectedInterval() === 'day') {
    <mat-button-toggle-group [value]="selectedChartOption()" (change)="onChartSelectionChange($event)"
                             class="custom-switch flex justify-center border-gray-200
                             mr-2 ml-2  md:mr-36 md:ml-36 mb-3.5 rounded-lg">
      <mat-button-toggle value="performance" class="flex-1 border-gray-200 ">
        Leistung
      </mat-button-toggle>
      <mat-button-toggle value="origin" class="flex-1 border-gray-200">
        Herkunft
      </mat-button-toggle>
    </mat-button-toggle-group>
  }

  @if (this.selectedEnergyOption() === 'battery') {

    <mat-button-toggle-group [value]="selectedBatteryOption()"
                             (change)="onBatterySelectionChange($event)"
                             class="custom-switch flex justify-center border-gray-200 mr-2 ml-2
                              md:mr-36 md:ml-36 mb-3.5 rounded-lg break-words battery-toggle">
      <mat-button-toggle value="charge"
                         class="flex-1 border-gray-200 bg-production-yellow break-words text-wrap w-full overflow-hidden leading-5">
        Ladezustand (SOC)
      </mat-button-toggle>
      <mat-button-toggle value="power"
                         class="flex-1 border-gray-200 bg-consumption-blue border-r-gray-200 border-r-1 border-l-1 break-words text-wrap w-full overflow-hidden leading-5">
        @if (this.selectedInterval() !== 'day') {
          Energie
        } @else {
          Leistung
        }
        (+ Laden / - Entladen)
      </mat-button-toggle>

      @if (this.selectedEnergyOption() === 'battery' && this.selectedInterval() === 'day') {
      <mat-button-toggle value="origin"
                         class="flex-1 border-gray-200 bg-production-yellow break-words text-wrap w-full overflow-hidden">
        Herkunft / Verwendung
      </mat-button-toggle>
      }
    </mat-button-toggle-group>
  }


  @if (this.selectedEnergyOption() === 'grid' && this.selectedInterval() === 'day') {
    <mat-button-toggle-group [value]="selectedChartOption()" (change)="onChartSelectionChange($event)"
                             class="custom-switch flex justify-center border-gray-200
                             mr-2 ml-2  md:mr-36 md:ml-36 mb-3.5 rounded-lg">
      <mat-button-toggle value="performance" class="flex-1 border-gray-200 ">
        Leistung
      </mat-button-toggle>
      <mat-button-toggle value="origin" class="flex-1 border-gray-200 break-words text-wrap w-full overflow-hidden">
        Herkunft / Verwendung
      </mat-button-toggle>
    </mat-button-toggle-group>

  }

  <div class="pb-5">
    <!-- Production Charts -->
    @if (this.selectedEnergyOption() === 'production') {

      @if (this.selectedChartOption() === 'origin') {
        <app-usage-chart
          [interval]="this.selectedInterval()"
          [date]="this.selectedDate()"
          [data]="this.resource.value()"
          [loading]="isLoading()">
        </app-usage-chart>
      } @else {
        @if (this.selectedChartOption() === 'performance') {
          <app-performance-chart
            [interval]="this.selectedInterval()"
            [date]="this.selectedDate()"
            [data]="this.resource.value()"
            [type]="this.selectedEnergyOption()"
            [loading]="isLoading()">
          </app-performance-chart>
        }
      }
    }

    <!-- Consumption Charts -->
    @if (this.selectedEnergyOption() === 'consumption') {
      @if (this.selectedChartOption() === 'origin') {
        <app-consumption-origin-chart
          [interval]="this.selectedInterval()"
          [date]="this.selectedDate()"
          [data]="this.resource.value()"
          [loading]="isLoading()">
        </app-consumption-origin-chart>
      } @else {
        @if (this.selectedChartOption() === 'performance') {
          <app-performance-chart
            [interval]="this.selectedInterval()"
            [date]="this.selectedDate()"
            [data]="this.resource.value()"
            [type]="this.selectedEnergyOption()"
            [loading]="isLoading()">
          </app-performance-chart>
        }
      }
    }

    <!-- Battery Charts -->
    @if (this.selectedEnergyOption() === 'battery') {
      @if (this.selectedInterval() === 'day') {
        @switch (this.selectedBatteryOption()) {
          @case ('origin') {
            <app-battery-origin-chart
              [interval]="this.selectedInterval()"
              [date]="this.selectedDate()"
              [data]="this.resource.value()"
              [loading]="isLoading()">
            </app-battery-origin-chart>
          }
          @default {
            <app-battery-power-day-chart
              [date]="this.selectedDate()"
              [data]="this.resource.value()"
              [loading]="isLoading()"
              [batteryType]="this.selectedBatteryOption()">
            </app-battery-power-day-chart>
          }
        }
      } @else if (this.selectedInterval() === 'month' && this.selectedBatteryOption() === 'charge') {
        <app-battery-charge-monthly-chart
          [date]="this.selectedDate()"
          [data]="this.resource.value()"
          [loading]="isLoading()">
        </app-battery-charge-monthly-chart>
      } @else if ((this.selectedInterval() === 'month' || this.selectedInterval() === 'year') && this.selectedBatteryOption() === 'power') {
        <app-battery-power-chart
          [interval]="this.selectedInterval()"
          [date]="this.selectedDate()"
          [data]="this.resource.value()"
          [loading]="isLoading()">
        </app-battery-power-chart>
      }
    }

    <!-- Grid Charts -->
    @if (this.selectedEnergyOption() === 'grid') {
      @if (this.selectedInterval() === 'day') {

        @if (this.selectedChartOption() === 'origin') {
          <app-grid-origin-chart
            [interval]="this.selectedInterval()"
            [date]="this.selectedDate()"
            [data]="this.resource.value()"
            [loading]="isLoading()">
          </app-grid-origin-chart>
        } @else {
          <app-grid-day-chart
            [date]="this.selectedDate()"
            [data]="this.resource.value()"
            [loading]="isLoading()">
          </app-grid-day-chart>
        }
      } @else if (this.selectedInterval() === 'month' || this.selectedInterval() === 'year') {
        <app-grid-bar-chart
          [interval]="this.selectedInterval()"
          [date]="this.selectedDate()"
          [data]="this.resource.value()"
          [loading]="isLoading()">
        </app-grid-bar-chart>
      }
    }

  </div>
</div>
